module.exports = __webpack_public_path__ + "img/skill_level_6_svg.15a7d3ad.svg";